import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Signal, ViewChild, WritableSignal, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IWaterSupplyZone, IWaterSupplyZoneGeo } from '../water-supply-zone.model';
import { WaterSupplyZoneService } from '../water-supply-zone.service';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { KeyValueFormComponent } from 'src/app/shared/components/forms/key-value-form/key-value-form.component';
import { WaterSupplyZoneGeoService } from '../water-supply-zone-geo.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { ScreenService } from 'src/app/core/services/screen.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { Ability } from '@casl/ability';
import { AuthService } from 'src/app/core/services/auth.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { PUNTI_CAMPIONAMENTO_COLUMNS, PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE, PUNTICAMPIONAMENTO_VISIBLECOLUMNS_DASHOBARD } from '../../punti-campionamento/punti-campionamento.config';
import { PuntiCampionamentoService } from '../../punti-campionamento/punti-campionamento.service';
import { QueryService } from 'src/app/core/services/query.service';
import { IPuntoCampionamento } from '../../punti-campionamento/punti-campionamento.model';
import { PageListComponent } from "../../../layout/pages/page-list/page-list.component";
import { CardComponent } from "../../../shared/components/cards/card/card.component";
import { TableComponent } from "../../../shared/components/table/table.component";
import { toSignal } from '@angular/core/rxjs-interop';



@Component({
  selector: 'app-wsz-dettaglio-page',
  standalone: true,
  imports: [
    CommonModule,
    PageDetailComponent,
    EditableCardComponent,
    TextFieldComponent,
    KeyValueFormComponent,
    GoogleMapsModule,
    PageListComponent,
    CardComponent,
    TableComponent
],
  templateUrl: './dettaglio-page.component.html',
  styleUrl: './dettaglio-page.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DettaglioPageComponent {
  columns = PUNTI_CAMPIONAMENTO_COLUMNS;
  visibleColumns = signal(PUNTICAMPIONAMENTO_VISIBLECOLUMNS_DASHOBARD);
  @Input() id = '0';
  dataPuntiCampionamento:Signal<IPuntoCampionamento[]>=signal([]);
  idDettaglio='0'
  detailLoaded =false
  editablePolygons: google.maps.Polygon[] = [];
  dati : any;
  checkOverlapMap=false
  form: FormGroup;
  createPermission: boolean = false;
  abilityDefined: boolean = false;
  model: WritableSignal<IWaterSupplyZoneGeo | undefined> = signal(undefined);
  reload: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
    center: google.maps.LatLngLiteral = { lat: 41.8992, lng: 12.5450 };
    zoom = 5.3;
    options: google.maps.MapOptions = {
      mapTypeId: 'roadmap',
  /*     tilt: 0,
      clickableIcons: false,
      disableDefaultUI: true,
      disableDoubleClickZoom: true,
      zoomControl: true,
      scrollwheel: false,
      gestureHandling: 'auto',
      keyboardShortcuts: false,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,  */
    };
    customClickFunction(row:any){

      if(row.uuid){
        this.navigateToDetailPuntoCampionamento(row.uuid.toString())
      }
  
    }

  constructor(
    private readonly fb: FormBuilder,
    public readonly service: WaterSupplyZoneGeoService,
    private route: ActivatedRoute,
    public readonly servicePuntiCampionamento: PuntiCampionamentoService,
    @Inject(PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE) public readonly queryServicePuntiCampionamento: QueryService<IPuntoCampionamento>,
    private router: Router,
    private screen: ScreenService,
    private ref:ChangeDetectorRef,
    private dialogService: DialogService,
    private cdr : ChangeDetectorRef,
    private ability: Ability,
    private authService: AuthService,
    private snackbarService: SnackbarService
  ) {
    this.form = this.fb.group({});
    this.route.paramMap.subscribe(params => {
      var id= params.get("id"); 
      if(id){
        this.dataPuntiCampionamento = toSignal(this.service.getPuntiCampionamento(id), { initialValue: [] });
      }

    })
  }
  ngOnInit(){
    this.authService.abilityDefined$.subscribe((abilityDefined) => {
      this.abilityDefined = abilityDefined;
      this.createPermission = this.ability.can('create', 'water-supply-zone');
      // Ora puoi fare altro dopo che l'abilità è stata definita
    });
    this.route.paramMap.subscribe(params => {
     var id= params.get("id"); 
     if(id){
      this.idDettaglio=id
      this.service.getById(id).subscribe(el=>{

         this.dati=el
         this.detailLoaded=true; 
         this.loadGeoJson(this.dati?.featureMultiPolygon, true)

         if(this.dati.isOverLap && Array.isArray(this.dati.listIsOverLapWsz)){

            this.checkOverlapMap = true
          
          this.dati.listIsOverLapWsz.forEach((intersecId:any) => {
            console.log(intersecId)
            this.service.getById(intersecId).subscribe((el:any)=>{
     
              this.loadGeoJson(el?.featureMultiPolygon!)
            })
          });
         }
         this.cdr.detectChanges()
        })
     }

    })
  }

    customActionClick:Function=(el:any)=>{
      if(this.createPermission){
        this.router.navigate([`water-supply-zone/${this.idDettaglio}/modifica-intersezioni`])

      }else{
        this.snackbarService.error("non hai i permessi per modificare la wsz")
      }
     
  
    }

  formatDateCreation(dateCreation : string){
    const isoString =dateCreation;
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate

  }
  
  getEditablePolygons(): google.maps.Polygon[] {
    return this.editablePolygons.filter(poly => poly.getEditable());
  }
  
  getGestore(){
    var denominazione = ''
    if(Array.isArray(this.dati?.idAreraGestore)){
      this.dati?.idAreraGestore.forEach((element:any) => {
        if(element.denominazione){
          denominazione= element.denominazione
        }
      });
    }
    return denominazione
  }

  loadGeoJson(data: any, canEdit = false) {
    this.waitForMapInit().then(() => {
      if (!this.map?.googleMap) return;
      const mapInstance = this.map.googleMap;
  
      if (this.isValidJSON(data)) {
        data = JSON.parse(data);
      }
  
      // Add new GeoJSON data
      const newFeatures =  mapInstance.data.addGeoJson(data);
  
      // Set style for all features
      mapInstance.data.setStyle((feature) => {
        return {
          fillColor: '#FF0000',
          fillOpacity: 0.35,
          strokeColor: '#FF0000',
          strokeOpacity: 0.8,
          strokeWeight: 1,
        };
      });
      // If editability is required, extract geometry and create editable polygons
      if (canEdit) {
        mapInstance.data.forEach((feature) => {

          const geometry = feature.getGeometry();
          if (!geometry) return;
  
          const type = geometry.getType();
  
          if (type === 'Polygon') {
            const polygon = geometry as google.maps.Data.Polygon;
            const paths = polygon.getArray().map((linearRing) =>
              linearRing.getArray().map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }))
            );
  
            var polygonCreated = new google.maps.Polygon({
              paths,
              strokeColor: 'green', 
              strokeOpacity: 0.8,
              strokeWeight: 1,
              fillColor:  'green', 
              fillOpacity: 0.35,
              editable: false,
              map: mapInstance,
            });
            this.editablePolygons.push(polygonCreated);
            mapInstance.data.remove(feature);
         
          } else if (type === 'MultiPolygon') {
            const multiPolygon = geometry as google.maps.Data.MultiPolygon;
            multiPolygon.getArray().forEach((polygon) => {
              const paths = polygon.getArray().map((linearRing) =>
                linearRing.getArray().map((latLng) => ({ lat: latLng.lat(), lng: latLng.lng() }))
              );
  
              var polygonCreated = new google.maps.Polygon({
                paths,
                strokeColor: 'green',
                strokeOpacity: 0.8,
                strokeWeight: 1,
                fillColor: 'green',
                fillOpacity: 0.35,
                editable: false,
                map: mapInstance,
              });
              this.editablePolygons.push(polygonCreated);
            });
           
            mapInstance.data.remove(feature);
            
          }
        });
      }
      
    const bounds = new google.maps.LatLngBounds();

    newFeatures.forEach((feature: any) => {
      const geometry = feature.getGeometry();
 
      geometry.forEachLatLng((latLng: google.maps.LatLng) => {
        bounds.extend(latLng);
      });
    });
 
 
    const center = bounds.getCenter();
    this.center = {
      lat: center.lat(),
      lng: center.lng(),
    };
 
     this.zoom = 10;
       this.ref.detectChanges()

  
    });

  }
  
  
  

   waitForMapInit(){
    return new Promise((resolve) => {
      const checkMap = setInterval(() => {
        if (this.map && this.map.googleMap) {
          clearInterval(checkMap);
          resolve(null);
        }
      }, 100); 
    });
  };

  addIntersectionWsz(){

  }

  isValidJSON(str:any){
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  deleteWsz(dato:any){
    this.service.deleteWsz(this.id).subscribe((el)=>{this.router.navigate(['water-supply-zone/lista'])})
    
  }
  
  private navigateToDetailPuntoCampionamento(uuid: string) {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    urlSegments.pop();
    urlSegments.pop();
    urlSegments.push('punti-campionamento');
    urlSegments.push(uuid.toString());
    const newUrl = urlSegments.join('/');
    this.router.navigate([newUrl]);
  }
}
